"use strict";
/** state: Final **/
/** family: Process **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var ProcessStep_1 = require("../ProcessStep");
var CLASS_NAME = 'i-process';
var Process = /** @class */ (function (_super) {
    __extends(Process, _super);
    function Process() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.processListRef = React.createRef();
        return _this;
    }
    Process.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.activeStep !== this.props.activeStep) {
            // automatically scroll active element to the centre
            var processListDOM = this.processListRef.current;
            var activeItemDOM = processListDOM.getElementsByClassName('i-process__list__item--active')[0];
            if (!activeItemDOM) {
                return;
            }
            var paddingLeftValue = window
                .getComputedStyle(activeItemDOM, null)
                .getPropertyValue('padding-left')
                .split('px')[0];
            processListDOM.scrollLeft =
                activeItemDOM.offsetLeft -
                    processListDOM.offsetLeft -
                    (processListDOM.offsetWidth - activeItemDOM.offsetWidth) / 2 +
                    parseFloat(paddingLeftValue) / 2;
        }
    };
    Process.prototype.render = function () {
        var _a = this.props, className = _a.className, activeStep = _a.activeStep, finishedIcon = _a.finishedIcon, children = _a.children, addonAfter = _a.addonAfter, addonBefore = _a.addonBefore, disableCollapse = _a.disableCollapse, disableMaxWidth = _a.disableMaxWidth, restProps = __rest(_a, ["className", "activeStep", "finishedIcon", "children", "addonAfter", "addonBefore", "disableCollapse", "disableMaxWidth"]);
        return (React.createElement("div", { role: "application", className: classNames(className, CLASS_NAME) },
            React.createElement("ul", __assign({ className: CLASS_NAME + "__list" }, restProps, { ref: this.processListRef }),
                addonBefore,
                React.Children.map(children, function (child, index) {
                    return React.cloneElement(child, {
                        activeStep: activeStep,
                        disableCollapse: disableCollapse,
                        disableMaxWidth: disableMaxWidth,
                        finishedIcon: finishedIcon,
                        order: index + 1,
                    });
                }),
                addonAfter)));
    };
    Process.Step = ProcessStep_1.ProcessStep;
    return Process;
}(React.Component));
exports.Process = Process;
//# sourceMappingURL=Process.js.map